export const MADLIB_TEMPLATES = {
  all: (anchorLabel: string) => `set reserve price to [multiplier:float]% of ${anchorLabel}`,
  between: (anchorLabel: string) => `[min:integer] and [max:integer] days, set reserve price to [multiplier:float]% of ${anchorLabel}`,
  greater: (anchorLabel: string) => `[min:integer] days, set reserve price to [multiplier:float]% of ${anchorLabel}`,
  less: (anchorLabel: string) => `[max:integer] days, set reserve price to [multiplier:float]% of ${anchorLabel}`,
  flatRate: {
    all: 'set reserve price to [multiplier:money:$]',
    between: '[min:integer] and [max:integer] days, set reserve price to [multiplier:money:$]',
    greater: '[min:integer] days, set reserve price to [multiplier:money:$]',
    less: '[max:integer] days, set reserve price to [multiplier:money:$]',
  },
};

export const SHELF_LIFE_BRACKET_OPTIONS: {
  [key: string]: {
    value: string;
    text: string;
  };
} = {
  ALL_INVENTORY: { value: 'all', text: 'All Inventory' },
  BETWEEN: { value: 'between', text: 'Between' },
  GREATER: { value: 'greater', text: 'Greater Than or Equal to' },
  LESS: { value: 'less', text: 'Less Than or Equal to' },
};

export const EXCEPTION_PARAMETER_OPTIONS = [
  { key: 'category', value: 'Category', label: 'Category' },
  { key: 'handling', value: 'Handling', label: 'Handling' },
  { key: 'brand', value: 'Brand', label: 'Brand' },
  { key: 'quality', value: 'Quality', label: 'Quality' },
  { key: 'custom', value: 'CustomClass', label: 'Custom' },
];

export const ReservePriceConstants = {
  title: 'Reserve Price',
  description: 'Configure your reserve price strategy using this 3-step workflow.',
  step1Title: 'Choose your reserve price anchor',
  step1Description: 'Select the reserve price anchor used for your default reserve price (step 2) and exceptions (step 3).',
  step2Title: 'Set your default reserve price',
  step2Description: 'Set reserve price rules for all inventory based on your selected anchor. You can add exceptions to this in the next step.',
  step2Action: 'Configure your shelf life bracket(s)',
  step2SubDescription:
    'Set pricing rules based on shelf life. Your default reserve price must cover all shelf life. There can be no overlaps or gaps in shelf life.',
  noShelfLife: 'Your inventory doesn’t include shelf life information, so pricing can only apply to “All inventory.”',
  shelfLifeCoverage: 'Shelf life coverage',
  addBracket: '+ Add Bracket',
  step3Title: 'Create exceptions (optional)',
  step3Description:
    'Set exception rules that override your default reserve price, for example, to assign a different reserve price to a specific product category. Shelf life not covered in an exception will default to your default reserve price rule in step 2.',
  step3Action: 'Exceptions',
  step3SubDescription:
    'Exceptions do not have to cover all shelf and can include gaps in shelf life brackets, however, there can be no overlap in shelf life brackets.',
  addException: '+ Add Exception',
  baseExceptionLabel: 'Base exception rules on *',
  selectParameter: 'Select a parameter',
  noExceptions: 'No exceptions have been added. Click “Add Exception” to define exceptions to your default reserve price.',
  save: 'Save',
  saving: 'Saving',
  saved: 'Settings saved successfully',
  percent: 'Percent',
  percentRequired: 'Percent is required',
  primaryAnchorRequired: 'Primary anchor is required',
  unsavedChanges: 'You have unsaved changes. If you leave without saving, your changes will be lost.',
  invalidSettings:
    'Your settings are invalid. You have errors in your settings, if you leave this page now your changes will be lost. Correct the errors and save before leaving.',
  Category: 'Category',
};
